import SvgIcon from '@mui/material/SvgIcon';
import { FC } from 'react';

import BRIcon from '@/assets/logos/icon_br.svg?react';
import { BrandIconProps } from '@/components/shared/logos/props';

const BrandIconBR: FC<BrandIconProps> = ({
  themeAware = true,
  primaryColor,
  ...other
}) => {
  return (
    <SvgIcon {...other}>
      <BRIcon />
    </SvgIcon>
  );
};

export default BrandIconBR;
